import React, { FunctionComponent, SVGProps } from 'react';

import { useTranslation } from 'react-i18next';

import BdsButton from '../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import BdsTextButton from '../../../../shared/components/v3/Buttons/BdsTextButton/BdsTextButton';
import { ARROW_LEFT_ICON } from '../../../../shared/constants/images';
import { TRANSLATIONS_AUTH } from '../../../../shared/translations/auth';
import { GenericAsyncVoidFunction, GenericVoidFunction } from '../../../../shared/types/genericTypes';
import './AuthError.scss';

interface AuthErrorProps {
  title: string;
  description: string;
  Icon: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>;
  primaryButton: {
    text: string;
    action: GenericVoidFunction;
  };
  secondaryButton?: {
    text: string;
    action: GenericAsyncVoidFunction;
  };
  handleGoBack: GenericVoidFunction;
}

const AuthError = ({ title, description, Icon, primaryButton, secondaryButton, handleGoBack }: AuthErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className="auth-card-container ae-card-container" data-experience="new">
      <div className="auth-card-go-back">
        <BdsTextButton action={() => handleGoBack(0)} iconLeft={ARROW_LEFT_ICON}>
          {t(TRANSLATIONS_AUTH.goBack)}
        </BdsTextButton>
      </div>
      <div className="flex flex-col gap-11">
        <div className="flex flex-col gap-6">
          <Icon className="ae-icon" />
          <div className="ae-title">{t(title)}</div>
          <div className="ae-description">{t(description)}</div>
        </div>
        <div className="flex flex-col gap-6 items-center">
          <BdsButton variant="primary" size="l" action={primaryButton.action}>
            {t(primaryButton.text)}
          </BdsButton>
          {secondaryButton && (
            <BdsButton variant="tertiary" size="s" action={secondaryButton.action}>
              {t(secondaryButton.text)}
            </BdsButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthError;
